import { useQuery } from '@tanstack/react-query';
import { useApiFetch } from './ApiProvider';

export const eventKeys = {
	list: (projectId: string, type?: string) =>
		['projects', projectId, 'events', type ?? 'all'] as const,
};

export function useEvents(projectId: string, type?: string) {
	const apiFetch = useApiFetch();
	return useQuery({
		queryKey: eventKeys.list(projectId, type),
		queryFn: () => {
			const params = new URLSearchParams({ limit: '100' });
			if (type) params.set('type', type);
			return apiFetch<Record<string, unknown>[]>(
				`/api/admin/projects/${projectId}/events?${params.toString()}`,
			);
		},
		enabled: !!projectId,
		staleTime: 30_000,
	});
}
